import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNew: false,
  country: "",
  wholeAlert: "none",
  checkIfEmpty: 0,
  loading: false,
  class: "default-loading",
  text: "Deleting",
  loginStatus: false,
  title: "",
  venueId: sessionStorage.getItem("managerVenueId")
    ? sessionStorage.getItem("managerVenueId")
    : "all",
  typeList: sessionStorage.getItem("mozrestVenueId")
    ? [
        {
          label: "Confirmed",
          value: "Confirmed",
        },
        {
          label: "Closed",
          value: "Closed",
        },
      ]
    : [
        {
          label: "Requests",
          value: "Requests",
        },
        {
          label: "Pending",
          value: "Pending",
        },
        {
          label: "Confirmed",
          value: "Confirmed",
        },
        {
          label: "Closed",
          value: "Closed",
        },
      ],
  type: sessionStorage.getItem("type")
    ? sessionStorage.getItem("type")
    : "Requests",
  sendTime: 0,
  updateTable: sessionStorage.getItem("updateTable")
    ? Number(sessionStorage.getItem("updateTable"))
    : 0,
  updateCalendar: 0,
  confirmedStatus: "all",
  closedStatus: "all",
  mozrestVenueId: sessionStorage.getItem("mozrestVenueId")
    ? sessionStorage.getItem("mozrestVenueId")
    : "",
  selectDates: "",
  selectStart: "",
  selectEnd: "",
  faStatus: false,
};

const commonplaceSlice = createSlice({
  name: "commonplace",
  initialState,
  reducers: {
    setNew(state, action) {
      state.isNew = action.payload.newTag;
    },
    setCountryAbbre(state, action) {
      state.country = action.payload.country;
      state.faStatus = action.payload.faStatus;
      console.log("action.payload.country");
      console.log(action.payload.country);
    },
    setWholeAlert(state, action) {
      state.wholeAlert = action.payload.next;
    },
    setCheckIfEmpty(state, action) {
      state.checkIfEmpty = action.payload.current;
    },
    alterSelectDates(state, action) {
      if (action.payload.start && action.payload.end) {
        state.selectDates = `${action.payload.start}/${action.payload.end}`;
        state.selectStart = action.payload.start;
        state.selectEnd = action.payload.end;
      } else if (action.payload.start && !action.payload.end) {
        state.selectDates = `${action.payload.start}/${action.payload.start}`;
        state.selectStart = action.payload.start;
        state.selectEnd = "";
      } else if (!action.payload.start) {
        state.selectDates = ``;
        state.selectStart = "";
        state.selectEnd = "";
      }
    },
    setMozrestVenueId(state, action) {
      if (action.payload.id) {
        state.typeList = [
          {
            label: "Confirmed",
            value: "Confirmed",
          },
          {
            label: "Closed",
            value: "Closed",
          },
        ];
        state.closedStatus = "all";
        sessionStorage.setItem("type", "Confirmed");
        state.type = "Confirmed";
      }
      if (state.mozrestVenueId && !action.payload.id) {
        state.typeList = [
          {
            label: "Requests",
            value: "Requests",
          },
          {
            label: "Pending",
            value: "Pending",
          },
          {
            label: "Confirmed",
            value: "Confirmed",
          },
          {
            label: "Closed",
            value: "Closed",
          },
        ];
        sessionStorage.setItem("type", "Requests");
        state.type = "Requests";
      }
      state.mozrestVenueId = action.payload.id;
      sessionStorage.setItem(
        "mozrestVenueId",
        action.payload.id ? action.payload.id : ""
      );
    },
    whetherSpinning(state, action) {
      state.loading = action.payload.loading;
      state.class = action.payload.class;
      state.text = action.payload.text;
    },
    alterLoginStatus(state, action) {
      state.loginStatus = action.payload.loginStatus;
    },
    setTitle(state, action) {
      state.title = action.payload.title;
      document.title =
        action.payload.title > 0 ? `(${action.payload.title}) Ambl` : `Ambl`;
    },
    setVenueId(state, action) {
      state.venueId = action.payload.venueId;
      console.log("lastest venueid");
      console.log(action.payload.venueId);
    },
    setTypeList(state, action) {
      state.typeList = action.payload.typeList;
    },
    setSendTime(state, action) {
      state.sendTime =
        typeof action.payload.sendTime === "string"
          ? Number(action.payload.sendTime)
          : action.payload.sendTime;
    },
    setType(state, action) {
      state.type = action.payload.type;
    },
    setUpdateTable(state, action) {
      state.updateTable = action.payload.updateTable;
    },
    setUpdateCalendar(state, action) {
      state.updateCalendar = action.payload.updateCalendar;
    },
    setConfirmedStatus(state, action) {
      state.confirmedStatus = action.payload.status;
    },
    setClosedStatus(state, action) {
      state.closedStatus = action.payload.status;
    },
  },
});

export const {
  whetherSpinning,
  alterLoginStatus,
  setTitle,
  setVenueId,
  setTypeList,
  setSendTime,
  setType,
  setUpdateTable,
  setConfirmedStatus,
  setClosedStatus,
  setMozrestVenueId,
  alterSelectDates,
  setUpdateCalendar,
  setWholeAlert,
  setCheckIfEmpty,
  setNew,
  setCountryAbbre,
} = commonplaceSlice.actions;

export default commonplaceSlice.reducer;
